import React, { memo } from "react";
import styles from "./UtilityHeader.module.scss";
import Button from "../../common/components/xepp/button/Button";
import { BackIcon, MobileMenu } from "../../assets/icons";
import { useConfigLayout } from "../../hooks/useConfigLayout";
import { SystemReferralMenuIcon } from "../../assets/sidemenu-icons";


type Props = {
	onMobileMenuClick: () => void;
};

const UtilityHeader: React.FC<Props> = memo((props: Props) => {
	const { onMobileMenuClick } = props;
	const {
		selectedCountry,
		selectedUtility,
		isExportButtonVisible,
		isBreadCrumbVisible,
		isBroadcastButtonVisible,
		pageTitle,
		handleExport,
		handleGoBack,
		handleBroadcast,
	} = useConfigLayout();

	return (
		<div>
			<div className={`${styles.container}`}>
				<div className={styles.rightSection}>
					<Button onClick={handleGoBack} leftIcon={<BackIcon style={{ marginRight: 5 }} />} variant="outline" type="button" text="Go Back" />
					{pageTitle && <span className={styles.pageTitle}>{pageTitle}</span>}
					{isBreadCrumbVisible && (
						<div className={styles.breadcrumb}>
							<div className={styles.breadcrumbItem}>Countries</div>
							{selectedCountry && (
								<>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>/</div>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>{selectedCountry.name}</div>
								</>
							)}
							{selectedUtility && (
								<>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>/</div>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>{selectedUtility.name}</div>
								</>
							)}
						</div>
					)}
				</div>
				<div className={styles.actions}>
					{isExportButtonVisible && <Button variant="outline" text="Export" onClick={handleExport} />}
					{isBroadcastButtonVisible && <Button  text="Broadcast" className={styles.broadcastButton} onClick={handleBroadcast} rightIcon={<SystemReferralMenuIcon />} />}
				</div>

			</div>
			<div className={styles.mobileContainer}>
				<MobileMenu className={styles.mobileMenu} onClick={onMobileMenuClick} />
			</div>
		</div>
	);
});

export default UtilityHeader;
